<template>
	<div class="tab-content-box">
		<el-alert title="允许通过前端网页查看待审核演出的详情" type="warning" :closable="false"></el-alert>
		<el-form :model="formData" ref="formData" label-position="top" class="MT10">
			<el-form-item prop="userIds" label="乐迷用户ID:">
				<el-input v-model="formData.userIds" type="textarea" placeholder="请输入乐迷用户ID" :rows="4"></el-input>
				<small class="from-tip"><span class="el-icon-warning"></span> ID间请使用英文逗号隔开</small>
			</el-form-item>
			<div v-if="idNameList && idNameList.length > 0" class="info-grid">
				<div v-for="item in idNameList" :key="item.id" class="info-card">
					<div class="info-id">ID: {{ item.id }}</div>
					<div class="info-name">乐迷用户名称: {{ item.name }}</div>
				</div>
			</div>
			<el-form-item>
				<el-button type="primary" @click="onSubmit" :loading="btnLoading">确认提交</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
	import {
		detailAction,
		editAction,
		addAction
	} from "../api";
	import '../tab-common.scss'
	export default {
		props: {
			// 接收父组件传递的激活状态
			isActive: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				formData: {
					id: "",
					type: 4,
					userIds: "",
				},
				btnLoading: false,
				idNameList: [],
				hasLoaded: false
			};
		},
		watch: {
			// 监听 isActive 变化
			isActive: {
				handler(val) {
					if (val && !this.hasLoaded) {
						this.getDataDetail();
					}
				},
				immediate: true
			}
		},
		computed: {
			rows() {
				const rows = [];
				for (let i = 0; i < this.idNameList.length; i += 8) {
					rows.push(this.idNameList.slice(i, i + 8));
				}
				return rows;
			}
		},
		methods: {
			async getDataDetail() {
				const res = await detailAction({
					type: this.formData.type,
				});
				const {
					state,
					msg,
					result
				} = res.data;
				if (state == 1) {
					this.formData = {
						...this.formData,
						...result
					};
					let originalList = result.idNameList ? result.idNameList : [];
					const map = new Map();
					this.idNameList = originalList.filter(item => {
						if (!map.has(item.id)) {
							map.set(item.id, true);
							return true;
						}
						return false;
					});
				} else {
					this.$message.error(msg || "请求失败");
				}

			},

			async onSubmit() {
				this.$refs["formData"].validate(async (valid) => {
					if (valid) {
						this.btnLoading = true;
						let _res = '';
						if (this.formData.id) {
							_res = await editAction(this.formData);
						} else {
							_res = await addAction(this.formData);
						}

						const {
							state,
							msg
						} = _res.data;
						this.btnLoading = false;
						if (state == 1) {
							this.$message.success("设置成功");
							this.getDataDetail();
						} else {
							this.$message.error(msg || "请求失败");
						}
					}
				});
			},
		},
	};
</script>
